/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';
// @ts-ignore
import { SchoolApiDto } from '../model/school.model';
// @ts-ignore
import { SchoolFinderCountryFiltersApiDto } from '../model/school-finder-country-filters.model';
// @ts-ignore
import { SchoolFinderFiltersApiDto } from '../model/school-finder-filters.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { SchoolFinderApiServiceInterface } from './school-finder.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class SchoolFinderApiService extends BaseService implements SchoolFinderApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param languageCode
   * @param countryCode
   * @param purposeCode
   * @param cityCode
   * @param courseTypeCode
   * @param childCourseTypeCode
   * @param quoteAvailable
   * @param courseCodes
   * @param schoolCodes
   * @param fromPrice
   * @param toPrice
   * @param fromRatingScore
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findSchools(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    countryCode?: string,
    purposeCode?: string,
    cityCode?: string,
    courseTypeCode?: string,
    childCourseTypeCode?: string,
    quoteAvailable?: boolean,
    courseCodes?: Array<string>,
    schoolCodes?: Array<string>,
    fromPrice?: number,
    toPrice?: number,
    fromRatingScore?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<SchoolApiDto>>;
  public findSchools(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    countryCode?: string,
    purposeCode?: string,
    cityCode?: string,
    courseTypeCode?: string,
    childCourseTypeCode?: string,
    quoteAvailable?: boolean,
    courseCodes?: Array<string>,
    schoolCodes?: Array<string>,
    fromPrice?: number,
    toPrice?: number,
    fromRatingScore?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<SchoolApiDto>>>;
  public findSchools(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    countryCode?: string,
    purposeCode?: string,
    cityCode?: string,
    courseTypeCode?: string,
    childCourseTypeCode?: string,
    quoteAvailable?: boolean,
    courseCodes?: Array<string>,
    schoolCodes?: Array<string>,
    fromPrice?: number,
    toPrice?: number,
    fromRatingScore?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<SchoolApiDto>>>;
  public findSchools(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    countryCode?: string,
    purposeCode?: string,
    cityCode?: string,
    courseTypeCode?: string,
    childCourseTypeCode?: string,
    quoteAvailable?: boolean,
    courseCodes?: Array<string>,
    schoolCodes?: Array<string>,
    fromPrice?: number,
    toPrice?: number,
    fromRatingScore?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling findSchools.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling findSchools.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>languageCode, 'languageCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'countryCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>purposeCode, 'purposeCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>cityCode, 'cityCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>courseTypeCode, 'courseTypeCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>childCourseTypeCode, 'childCourseTypeCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>quoteAvailable, 'quoteAvailable');
    if (courseCodes) {
      courseCodes.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'courseCodes');
      });
    }
    if (schoolCodes) {
      schoolCodes.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'schoolCodes');
      });
    }
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fromPrice, 'fromPrice');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>toPrice, 'toPrice');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fromRatingScore, 'fromRatingScore');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v1/school-finder/search`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SchoolApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param languageCode
   * @param purposeCode
   * @param countryCode
   * @param filterKey
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSchoolCountryFilters(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    purposeCode?: string,
    countryCode?: string,
    filterKey?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<SchoolFinderCountryFiltersApiDto>;
  public getSchoolCountryFilters(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    purposeCode?: string,
    countryCode?: string,
    filterKey?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<SchoolFinderCountryFiltersApiDto>>;
  public getSchoolCountryFilters(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    purposeCode?: string,
    countryCode?: string,
    filterKey?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<SchoolFinderCountryFiltersApiDto>>;
  public getSchoolCountryFilters(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    languageCode?: string,
    purposeCode?: string,
    countryCode?: string,
    filterKey?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getSchoolCountryFilters.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getSchoolCountryFilters.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>languageCode, 'languageCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>purposeCode, 'purposeCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'countryCode');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filterKey, 'filterKey');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v2/school-finder/filters/countries`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SchoolFinderCountryFiltersApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSchoolFiltersV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<SchoolFinderFiltersApiDto>;
  public getSchoolFiltersV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<SchoolFinderFiltersApiDto>>;
  public getSchoolFiltersV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<SchoolFinderFiltersApiDto>>;
  public getSchoolFiltersV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getSchoolFiltersV2.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getSchoolFiltersV2.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v2/school-finder/filters`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<SchoolFinderFiltersApiDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
